// extracted by mini-css-extract-plugin
module.exports = {"desc":"LearningPlans_desc__kK8C_"};